module.exports = __webpack_public_path__ + "img/guide_4_4.7c84b696.svg";